import { detectThemeMode } from '@synoptic/ui-kit/theme/detect-theme-mode.js';
import { useEffect } from 'react';
import { useLocation, useRouteLoaderData } from 'react-router';

export const PageViewTracking = () => {
  const location = useLocation();
  const loaderData = useRouteLoaderData('root') as {
    colorScheme?: 'dark' | 'light';
  };

  const fullPath = location.pathname + location.search + location.hash;

  useEffect(() => {
    window.mixpanel?.track_pageview({
      'Color Scheme': loaderData.colorScheme || detectThemeMode(),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fullPath]);

  return null;
};
